import SectionHeader from "@/components/feature/panel/SectionHeader";
import { useAuth } from "@/hooks/useAuth";
import { resolveTeacherIdentity } from "@/lib/profile";

export default function Profil() {
  const { user } = useAuth();
  const identity = resolveTeacherIdentity(user);

  const rows = [
    { label: "Ad Soyad", value: identity.name, icon: "ri-user-line" },
    { label: "Branş", value: identity.branch || "Belirtilmedi", icon: "ri-book-2-line" },
    { label: "E-posta", value: identity.email || "—", icon: "ri-mail-line" },
    { label: "Telefon", value: identity.phone || "Belirtilmedi", icon: "ri-phone-line" },
    { label: "Şehir", value: identity.city || "Belirtilmedi", icon: "ri-map-pin-line" },
    { label: "İlçe", value: identity.district || "Belirtilmedi", icon: "ri-building-line" },
    { label: "Cinsiyet", value: identity.gender || "Belirtilmedi", icon: "ri-user-heart-line" },
    { label: "Doğum Tarihi", value: identity.birthDate || "Belirtilmedi", icon: "ri-calendar-line" },
    { label: "Deneyim", value: identity.experience ? `${identity.experience} yıl` : "Belirtilmedi", icon: "ri-briefcase-line" },
    { label: "Eğitim / Mezuniyet", value: identity.education || "Belirtilmedi", icon: "ri-graduation-cap-line" },
    { label: "Adres", value: identity.address || "Belirtilmedi", icon: "ri-home-line" },
    { label: "Biyografi", value: identity.bio || "Belirtilmedi", icon: "ri-file-text-line" },
  ];

  return (
    <div className="space-y-6 max-w-2xl">
      <SectionHeader
        title="Profil"
        description="Hesap ve profil bilgilerin."
      />

      <div className="rounded-lg border border-background-200 bg-background-50 p-6">
        <div className="flex items-center gap-4">
          <span className="w-16 h-16 flex items-center justify-center rounded-full bg-primary-950 text-background-50 font-heading font-bold text-xl">
            {identity.initials}
          </span>
          <div>
            <p className="font-heading font-semibold text-base text-foreground-950">{identity.name}</p>
            <p className="text-sm text-foreground-500">
              {identity.branch ? `${identity.branch} Öğretmeni` : "Öğretmen"}
            </p>
          </div>
        </div>

        <div className="mt-6 space-y-3">
          {rows.map((row) => (
            <div
              key={row.label}
              className="flex items-center gap-3 rounded-md bg-background-100 px-4 py-3"
            >
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50 text-foreground-500 shrink-0">
                <i className={row.icon} aria-hidden="true"></i>
              </span>
              <div className="min-w-0">
                <p className="text-xs text-foreground-500">{row.label}</p>
                <p className="text-sm font-medium text-foreground-900 truncate">{row.value}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}